// src/landingRoutes.tsx
// The public half of the route table, branched by landing mode: 'it-solutions'
// and 'builder' render `/` inside PublicLayout (legacy backdrop); 'showcase' is a
// top-level lazy route of its own. PublicLayout always keeps the other public routes.

import { lazy, Suspense } from 'react'
import type { RouteObject } from 'react-router'
import PublicLayout from './layouts/PublicLayout'
import type { LandingMode } from './lib/landing-mode'

// Eager-load the fallback landing pages (first paint), as before.
import ContactLandingPage from '@/components/landing/LandingPage'
import BuilderLandingPage from '@/components/landing/BuilderLandingPage'

const ShowcaseLayout = lazy(
  () => import('@/components/landing/showcase/ShowcaseLayout'),
)

function ShowcaseEntry() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-black" />}>
      <ShowcaseLayout />
    </Suspense>
  )
}

/** Routes for `/` and the PublicLayout children (auth pages) in the given mode. */
export function publicRoutes(
  mode: LandingMode,
  children: RouteObject[],
): RouteObject[] {
  if (mode === 'showcase') {
    return [
      { path: '/', element: <ShowcaseEntry /> },
      { element: <PublicLayout />, children },
    ]
  }

  const LandingPage =
    mode === 'builder' ? BuilderLandingPage : ContactLandingPage
  return [
    {
      element: <PublicLayout />,
      children: [{ path: '/', element: <LandingPage /> }, ...children],
    },
  ]
}
